import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AppConfig } from 'src/app/core/_config/app.config';
import { DirectDebitContractLite } from '../../models/directDebitContractLite';

@Component({
    selector: 'automatic-debit-table',
    templateUrl: './automatic-debit-table.component.html',
    styleUrls: ['./automatic-debit-table.component.scss'],
})
export class AutomaticDebitTableComponent implements OnChanges {
    page = 1;
    pageSize = 50;
    @Input() contractListFilter: DirectDebitContractLite[] = [];
    collectionSize = this.contractListFilter.length;
    contractListPaginated: DirectDebitContractLite[] = [];

    constructor(private _config: AppConfig) {}
    ngOnChanges(changes: SimpleChanges): void {
        if (changes['contractListFilter']) {
            this.loadPaginator();
            this.collectionSize = this.contractListFilter.length;
        }
    }
    loadPaginator() {
        this.contractListPaginated = this.contractListFilter
            .map((item, i) => ({ id: i + 1, ...item }))
            .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
    }

    viewContract(contract: DirectDebitContractLite) {
        let contractId = contract?.contractId;
        this.redirect(`${this._config.urlOldAfs}AccountsReceiving/AccountsReceiving/?ContractId=${contractId}`);
    }

    private redirect(url: string, target = '_blank'): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            try {
                resolve(!!window.open(url, target));
            } catch (e) {
                reject(e);
            }
        });
    }
}
